import Api from './api';

export const getAllByParentOrganizationCategoryId = async id => { 
  let data = [];
  await Api.get(`/organizationcategory/all/parent/${id}`)
  .then(result => {
    data = result.data
  })
  .catch(err => {
    data = err;
  })
  
  return data;
}